import { createTheme } from '@mui/material/styles'

const Font = `"Roboto","Helvetica", "Arial", sans-serif`

declare module '@mui/material' {
  interface TypographyPropsVariantOverrides {
    body: true
  }
  interface TypographyClasses {
    body: string
  }
}

declare module '@mui/material/styles' {
  interface TypographyVariantsOptions {
    body?: React.CSSProperties
  }
  interface TypographyVariants {
    body: React.CSSProperties
  }
}

const VariantsTheme = createTheme({
  typography: {
    // adding the new 'body' variant
    body: {
      fontFamily: Font,
      margin: 0,
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '150%',
      letterSpacing: '0.009rem',
    },
    // updating the default 'caption' variant
    caption: {
      fontSize: '0.75rem',
      lineHeight: '133.4%',
    },
  },
})

export default VariantsTheme
